/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Payment_QuestionInputs */

const en_landing_faq_payment_question = /** @type {(inputs: Landing_Faq_Payment_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which payment providers are supported?`)
};

const zh_landing_faq_payment_question = /** @type {(inputs: Landing_Faq_Payment_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持哪些支付方式？`)
};

/**
* | output |
* | --- |
* | "Which payment providers are supported?" |
*
* @param {Landing_Faq_Payment_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_payment_question = /** @type {((inputs?: Landing_Faq_Payment_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Payment_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_payment_question(inputs)
	return zh_landing_faq_payment_question(inputs)
});
export { landing_faq_payment_question as "landing.faq.payment.question" }